// 数学渲染缓存服务 - 提升滚动性能

interface CacheEntry {
  displayMode: boolean;     // shouldDisplayInline的结果
  renderedHTML: string;     // 最终渲染结果
}

class MathRenderCache {
  private cache = new Map<string, CacheEntry>();

  /**
   * 生成缓存键
   */
  private generateCacheKey(formula: string, options: any = {}): string {
    return `${formula}_${JSON.stringify(options)}`;
  }

  /**
   * 获取显示模式缓存
   */
  getDisplayMode(formula: string): boolean | null {
    const key = this.generateCacheKey(formula);
    const entry = this.cache.get(key);
    return entry ? entry.displayMode : null;
  }

  /**
   * 获取渲染结果缓存
   */
  getRenderedHTML(formula: string, options: any = {}): string | null {
    const key = this.generateCacheKey(formula, options);
    const entry = this.cache.get(key);
    return entry ? entry.renderedHTML : null;
  }

  /**
   * 设置缓存 - 同时缓存显示模式和渲染结果
   */
  setCache(formula: string, displayMode: boolean, renderedHTML: string, options: any = {}): void {
    const key = this.generateCacheKey(formula, options);
    this.cache.set(key, {
      displayMode,
      renderedHTML
    });
  }

  /**
   * 检查是否有缓存
   */
  hasCache(formula: string, options: any = {}): boolean {
    const key = this.generateCacheKey(formula, options);
    return this.cache.has(key);
  }

  /**
   * 清空缓存 (如果需要)
   */
  clear(): void {
    this.cache.clear();
  }

  /**
   * 获取缓存统计信息
   */
  getStats(): { size: number; keys: string[] } {
    return {
      size: this.cache.size,
      keys: Array.from(this.cache.keys())
    };
  }
}

// 导出单例
export const mathRenderCache = new MathRenderCache();